import type { ProfileCvByLocale, ProfileCvContent, ProfileLocale } from '../../redux/features/jobFormSlice';

function contentScore(content: ProfileCvContent): number {
  return (
    (content.profileTitle.trim() ? 1 : 0) +
    content.profileWorkExperiences.length +
    content.profileEducation.length +
    content.profileProjects.length +
    content.profileSkills.filter((s) => s.trim()).length
  );
}

function hasAnyContent(content: ProfileCvContent): boolean {
  return contentScore(content) > 0;
}

/**
 * Picks which language's CV content to use for a locale-sensitive flow (e.g. tailoring a CV for
 * a job page in a given language). Prefers `preferredLocale` when the user has filled it in;
 * otherwise falls back to whichever language has the most content, so a user who only wrote a
 * Finnish CV still gets a sensible result when applying to a job on the English site.
 */
export function pickProfileLocaleContent(
  byLocale: ProfileCvByLocale,
  preferredLocale: ProfileLocale
): ProfileCvContent {
  const preferred = byLocale[preferredLocale];
  if (preferred && hasAnyContent(preferred)) {
    return preferred;
  }

  const [best] = (Object.values(byLocale) as ProfileCvContent[])
    .filter(hasAnyContent)
    .sort((a, b) => contentScore(b) - contentScore(a));

  return best ?? preferred;
}
